module.exports = __webpack_public_path__ + "static/img/pico48.b0ec3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico48.png
// module id = 9oYZ
// module chunks = 0